import { Inject } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { element } from 'protractor';

export abstract class Cookie {
    abstract get(): any;
    abstract put(key:string,value:string, expiredTime?:number):void;
    abstract remove(key:string):void;
    abstract getAll(): any;
}

export class CookieBrowser implements Cookie {
    
    remove(key:string): any{
        let _cookies = window.document.cookie;
        let __cookieText = `${key}=; path=/;expire=Thu, 01 Jan 1970 00:00:01 GMT`;
        window.document.cookie = __cookieText;
    }

    get(): Object {
        let cookies:Object = {};
        let _cookies = window.document.cookie;
        _cookies.split("; ").map(function (element) {
            let __cookEl = element.split("=");
            cookies[__cookEl[0]] = __cookEl[1];
        });
        return cookies;
    }

    put(key:string, value:string, expiredTime:number = 30*60*1000): void{
        let expire = new Date();
        expire = new Date(expire.getTime()+expiredTime);
        let __cookieText = `${key}=${value}; path=/;expires=${expire.toUTCString()}`;
        window.document.cookie = __cookieText;
    }

    getAll(){
        return window.document.cookie;
    }
}

export class CookieNode implements Cookie{
    private cookies = {};
    constructor(@Inject(REQUEST) private req: any){
        if (this.req.headers.cookie){
            let aux: string[] = this.req.headers.cookie.split(";");
            aux.forEach(element => {
                let cookie = element.split("=");
                this.cookies[cookie[0]] = cookie[1];
            });
        }
    }
    get():any{
      return this.cookies || {};
    }
    put(key:string, value:string, expiredTime:number = 0):void{
        this.cookies[key] = value;
    }
    remove(key:string){
        
    }

    getAll():any{
        return this.cookies;
    }
}